import { render, staticRenderFns } from "./PgaDatePicker.vue?vue&type=template&id=4e648510&"
import script from "./PgaDatePicker.vue?vue&type=script&lang=ts&"
export * from "./PgaDatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e648510')) {
      api.createRecord('4e648510', component.options)
    } else {
      api.reload('4e648510', component.options)
    }
    module.hot.accept("./PgaDatePicker.vue?vue&type=template&id=4e648510&", function () {
      api.rerender('4e648510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaDatePicker.vue"
export default component.exports